export enum IceFeedbackFormSteps {
  prompt = 1,
  details = 2,
  success = 3,
}
